export const downloadCSV = (rows: string[][], fileName = 'download') => {
  const bom = new Uint8Array([0xef, 0xbb, 0xbf])
  const blob = new Blob([bom, rows.join('\r\n')], { type: 'text/csv' })
  const element = document.createElement('a')
  const objectUrl = window.URL.createObjectURL(blob)
  element.href = objectUrl
  element.setAttribute('download', fileName)
  document.body.appendChild(element)
  element.click()
  window.URL.revokeObjectURL(objectUrl)
  document.body.removeChild(element)
}
